<template>
  <v-menu
    :value="value"
    :position-x="position.x"
    :position-y="position.y"
    absolute
    offset-y
    @input="$emit('input')"
  >
    <v-list>
      <v-list-tile
        v-for="(item, index) in menuText"
        :key="index"
        @click="$emit('click', index)"
      >
        <v-list-tile-title :style="index === 1 ? 'color: red;' : ''">
          {{ item }}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    position: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuText: [ '交換する', '撤去する' ]
    }
  }
}
</script>
